<template>
    <footer class='container-fluid'>
        <div class='row'>
            <div class='col-md centered'>
                <img src='../../assets/logo_footer.png' class='img-fluid' alt='Credicys'/>
            </div>
            <div class='col-md'>
                <h4>Credicys</h4>
                <p>Credicys est la plateforme de traitement des petites créances à destination des entrepreneurs et des particuliers.</p>
                <p>44 rue de Douai<br>75009 – Paris</p>
                <p><a href='https://www.credicys.fr/contact/' target="_blank">Nous écrire</a><br></p>
                <p><a href='https://www.credicys.fr/mentions-legales/' target='_blank'>Mentions Légales</a><br></p>
                <p><a href='https://www.credicys.fr/politique-de-confidentialite/' target='_blank'>Politique de confidentialité</a><br></p>
            </div>
            <div class='col-md'>
                <h4>Découvrir</h4>
                <ul>
                    <li><a href='https://www.credicys.fr/comment-ca-marche/' target='_blank'>Comment ça marche ?</a></li>
                    <li><a href='https://www.credicys.fr/tarifs/' target='_blank'>Tarifs</a></li>
                    <li><a href='https://www.credicys.fr/fiches-pratiques/' target='_blank'>Fiches pratiques</a></li>
                    <li><a href='https://www.credicys.fr/contact/' target='_blank'>Contact</a></li>
                </ul>
            </div>
        </div>
        <div class='row creditRow'>
            <div class='col-8 centered credit'>
                <p>© 2019 Credicys | Plateforme de recouvrement des Commissaires de justice</p>
            </div>
            <div class='col-4 centered socials'></div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'footer-bar'
    }
</script>

<style lang='scss'>
    footer {
        .col {
            min-width: 100%;
        }
        background-color: #222222;
        color: #ffffff;
        padding: 50px 0;
        font-size: 14px;
        h4 {
            color: #d5d5d5;
            font-size: 16px;
            padding: 15px 0;
        }
        a {
            color: #aebdc6;
            &:visited {
                line-height: inherit;
            }

            &:visited, &:focus {
                text-decoration: none;
                outline: 0;
            }

            &:hover {
                text-decoration: underline;
                color: #fff;
            }
        }

        ul {
            color: #cccccc;
            list-style-type: square;
            padding: 5px 10px 5px 30px;
            background: rgba(0,0,0,.03);
            li {
                position: relative;
                border-color: rgba(255,255,255,.08);
                padding: 10px 0 10px 0;
                &:after {
                    content: '';
                    display: block;
                    width: 70px;
                    border-width: 0 0 1px;
                    border-style: solid;
                    position: absolute;
                    left: -20px;
                    bottom: 0;
                }
            }
        }
        .creditRow {
            padding: 3em 0 1em 0;
            border-top: 1px solid rgba(255,255,255,.1);
        }
        .credit {
            min-width: 100%;
        }
        .socials {
            font-size: 15px;
            a {
            padding: 0 1em 0 1em;
                border: none;
                &:hover{
                    text-decoration: none;
                }
            }
        }
    }

    @media(min-width:768px){
        footer {
            .col {
                min-width: auto;
            }
            .credit {
                min-width: auto;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/FooterBar.vue